<template lang="pug">
  .component-backoffice-zone-list.component-backoffice-category-list
    .row.column
      .row
        .column.small-12.large-6.category(v-for="(zone, index) in zones", :class="{ active: activeIndex === index}", v-on:click="setActive(index)")
          .inner-content.card.text-center
            .row.text-center
              .column.text-left
                h2 {{ zone.name }} &nbsp;
              .column.small-1(v-if="activeIndex === index")
                i.fa.fa-trash.fa-2x(@click="deleteZone")
                i.fa.fa-edit.fa-2x(@click="editZone")
                ModalReveal(ref="revealGeoJson")
                  div.text-right(slot="trigger")
                    a.fa-stack.fa-md(@click="showGeoJson" title="Copy GeoJson to clipboard")
                      i.fa.fa-copy.fa-2x.fa-stack-1x.fa-inverse
                  .row
                    .column
                      loading-spinner(v-if="spin")
                      textarea(v-else :value ='geoJson' id="geoJsonToCopy" rows=30)
                  .row
                    .column
                      button.button(@click="copyToClipboard" :disabled="geoJson==''") Copy to clipboard

    //.row.column.map
      google-map(v-if="zones[activeIndex] && (mapCenter.lat !== 0 && mapCenter.lng !== 0)",
        ref="map", :api-key="mapsApiKey", :center="mapCenter", :libraries="['places','visualization','drawing']")
        google-map-polygon(v-if="zones[activeIndex]", v-for="p in zones[activeIndex].poly", :positions="p")
</template>

<script>
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import GoogleMap from '../../lib/map/GoogleMap'
import GoogleMapPolygon from '../../lib/map/GoogleMapPolygon'
import MaggieHelper from '../../maggieHelper'
import ModalReveal from "../../components/structure/foundation/ModalReveal";
import ActionButton from "../../components/structure/ui/ActionButton";
import LoadingSpinner from "../../components/structure/LoadingSpinner";

export default {
  name: 'ZoneList',
  components: {LoadingSpinner, GoogleMap, GoogleMapPolygon, ModalReveal, ActionButton},
  data() {
    return {
      activeIndex: 0,
      zones: [],
      mapsApiKey: window.env.GOOGLE_MAPS_KEY,
      mapCenter: {
        lat: 0,
        lng: 0,
      },
      geoJson: '',
      spin: true,
      geoJsonMerged: '',
    }
  },
  created() {
    KeplerBackofficeSdk.configuration.get((data) => {
      this.mapCenter.lat = data.application.application_default_latitude.value
      this.mapCenter.lng = data.application.application_default_longitude.value
    })
    this.loadZones()
  },
  methods: {
    loadZones() {
      KeplerBackofficeSdk.zones.list.all((data) => {
        this.zones = data
      })
    },
    setActive(index) {
      if (this.activeIndex === index) {
        return
      }
      this.activeIndex = index
    },
    deleteZone() {
      var zone = this.zones[this.activeIndex]
      this.$confirm('Are you sure?', `Do you really want to delete Z${zone.id} - ${zone.name}?`, () => {

        KeplerBackofficeSdk.zones.select(zone.id).remove((data) => {
          this.loadZones()
          MaggieHelper.notification('zone-delete', 'Zone deleted successfully')
          this.activeIndex = 0
        })
      })
    },

    editZone() {
      var zone = this.zones[this.activeIndex]
      this.$router.push({name: 'edit-zone', params: {id: zone.id}})
    },
    showGeoJson() {
      this.geoJson = ''
      this.spin =  true
      var zone = this.zones[this.activeIndex]
      KeplerBackofficeSdk.zones.select(zone.id).getGeoJson((data) => {
        this.geoJson = JSON.stringify(data)
        this.spin = false
      })

    },
    copyToClipboard() {
        document.getElementById('geoJsonToCopy').select()
        document.execCommand("copy")
        MaggieHelper.notification('GeoJson copied to Clipboard')
    },
  }
}
</script>

<style scoped lang="sass">
.component-backoffice-zone-list
  .map
    height: 400px

  .zone-edit
    color: white

</style>



// WEBPACK FOOTER //
// ZoneList.vue?13200f1b